import { useEffect } from "react";

const SITE = "https://eathiplate.com";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/g)?.forEach((pair) => {
      const [, k, v] = pair.match(/\[(\S+)="([^"]+)"\]/);
      el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const reviewsJsonLd = (reviews) => {
  const rated = reviews.filter((r) => r.stars >= 1);
  if (!rated.length) return null;
  const avg = rated.reduce((s, r) => s + r.stars, 0) / rated.length;
  return {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "@id": `${SITE}/#business`,
    name: "HiPlate",
    url: `${SITE}/`,
    image: `${SITE}/og-image.jpg`,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: Math.round(avg * 10) / 10,
      bestRating: 5,
      worstRating: 1,
      reviewCount: rated.length,
    },
    review: rated.map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.name },
      reviewRating: { "@type": "Rating", ratingValue: r.stars, bestRating: 5, worstRating: 1 },
      reviewBody: r.quote,
      ...(r.role ? { description: r.role } : {}),
    })),
  };
};

export const useSEO = ({ title, description, path }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [title, description, path]);
};
